module.exports = __webpack_public_path__ + "img/add-icon.665b99cc.svg";